export default function LogsTab({ logs }) {
  return (
    <div data-testid="logs-tab">
      <h2 className="text-2xl font-bold mb-6">Logs del Sistema</h2>
      <div className="bg-white rounded-xl border overflow-hidden max-h-[600px] overflow-y-auto">
        {logs.length === 0 ? (
          <div className="p-8 text-center text-gray-500">No hay logs</div>
        ) : (
          <table className="w-full">
            <thead className="bg-gray-50 sticky top-0">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500">Timestamp</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500">Tipo</th>
                <th className="px-4 py-3 text-left text-xs font-medium text-gray-500">Detalles</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {logs.map((log, idx) => (
                <tr key={idx}>
                  <td className="px-4 py-3 text-xs">{new Date(log.timestamp).toLocaleString()}</td>
                  <td className="px-4 py-3 text-xs">
                    <span className={`px-2 py-1 rounded-full text-xs ${log.log_type === 'error' ? 'bg-red-100 text-red-800' : 'bg-blue-100 text-blue-800'}`}>{log.log_type}</span>
                  </td>
                  <td className="px-4 py-3 text-xs">{log.message || JSON.stringify(log).slice(0, 100)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
